import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';
import { Day, DAY_ATTRIBUTE_CURRENT_DAY, DAY_ATTRIBUTE_SELECTED_DAY, DayAttribute, ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT, GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT } from '../../model/grid-calendar';
import { GridCalendarUtils } from '../../utils/grid-calendar-utils';

@Component( {
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'td[grid-calendar-day]',
    templateUrl: './his-display-grid-calendar-day.component.html',
    styleUrls: ['./his-display-grid-calendar-day.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisDisplayGridCalendarDayComponent implements OnInit {
    readonly gridCalendarUtils = inject( GridCalendarUtils );
    private readonly hisBaseGlobalsService = inject( HisBaseGlobalsService );

    @Input() public day!: Day;
    @Input() public monthId!: number;
    @Input() public monthOfYear: string = '';
    @Input() public year: string = '';
    @Output() public dateSelected: EventEmitter<{ day: Day, isFrom: boolean }> = new EventEmitter<{ day: Day, isFrom: boolean }>();
    @ViewChild( 'dayoverlay', { static: true } ) private overlayPanel!: OverlayPanel;

    public selectedDay: DayAttribute = DAY_ATTRIBUTE_SELECTED_DAY;
    public currentDay: DayAttribute = DAY_ATTRIBUTE_CURRENT_DAY;
    public readonly tooltipDateFormat: string;
    public currentDate: Date = new Date();

    constructor() {
        this.tooltipDateFormat = this.hisBaseGlobalsService.getLanguage() === 'de' ? GERMAN_DATE_WITH_DAYOFWEEK_PIPE_FORMAT : ENGLISH_DATE_WITH_DAYOFWEEK_PIPE_FORMAT;
    }

    ngOnInit(): void {
        this.currentDate.setFullYear( Number( this.year ) );
        this.currentDate.setMonth( this.monthId - 1 );
        this.currentDate.setDate( this.day.dayId );
    }

    toggleOverlayPanel( $event: MouseEvent ): void {
        this.overlayPanel.toggle( $event );
    }

    selectDay( isFrom: boolean ): void {
        this.dateSelected.emit( { day: this.day, isFrom: isFrom } );
    }

    determineCssClass(): string {
        if ( this.day.events[0]?.css && !this.day.dayAttributes[0]?.mustBeDisplayed ) {
            return this.day.events[0].css;
        }
        if ( this.day.dayAttributes[0]?.css ) {
            return this.day.dayAttributes[0].css;
        }
        return '';
    }

    getAllDayAttributes(): DayAttribute[] {
        const attributes: DayAttribute[] = [...this.day.dayAttributes];
        if ( this.day.isSelected ) {
            attributes.push( this.selectedDay );
        }
        if ( this.day.isToday ) {
            attributes.push( this.currentDay );
        }
        return attributes.reverse();
    }

    getButtonTitle( date: string, eventDescription: string | null ): string {
        let tooltip = date;
        if ( eventDescription ) {
            tooltip += ' : ';
            tooltip += this.gridCalendarUtils.getText( eventDescription );
        }
        return tooltip;
    }
}
